<template>
	<HeroDiagonal v-bind="$props">
		<slot />
	</HeroDiagonal>
</template>

<script lang="ts" setup>
import HeroDiagonal from '#base/app/components/template/HeroDiagonal.vue';
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { VideoType } from '#base/core/types/VideoType';

defineProps<{
	backgroundVideo?: VideoType;
	pageTitle: string;
	pageTitlePrefix?: string;
	pageTitleSuffix?: string;
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
}>();
</script>
